export const fileNameFromPath = (filePath: string) => filePath.split('\\').pop().split('/').pop();
